import { Route, Switch } from 'react-router';
import { Redirect } from 'react-router-dom';
import BillCreate from './billCreate';
import BillExports from './billExports';
import BillExportDetails from './billExportDetails';

const QuickBooks = () => {
    return (
        <Switch>
            <Route exact path='/accounting/bill' component={BillCreate} />
            <Route exact path='/accounting/bill/exports' component={BillExports} />
            <Route exact path='/accounting/bill/exports/details/:id' component={BillExportDetails} />
            <Redirect to='/' /> {/* The '/accounting' route is not a real page and falls through to root */}
        </Switch>
    );
};

export default QuickBooks;